import { useNavigate } from 'react-router-dom';

export default function QuickActions() {
  const navigate = useNavigate();

  const actions = [
    { icon: 'ri-file-list-3-line', label: '订单管理', color: 'bg-teal-50 text-teal-600', path: '/orders' },
    { icon: 'ri-user-line',        label: '客户管理', color: 'bg-emerald-50 text-emerald-600', path: '/customers' },
    { icon: 'ri-file-text-line',   label: '核算管理', color: 'bg-amber-50 text-amber-600', path: '/accounting' },
    { icon: 'ri-bar-chart-line',   label: '数据统计', color: 'bg-cyan-50 text-cyan-600', path: '/analytics' },
    { icon: 'ri-settings-3-line',  label: '偏好设置', color: 'bg-orange-50 text-orange-600', path: '/settings' },
  ];

  return (
    <div className="mb-5 md:mb-8">
      {/* Mobile: horizontal scroll */}
      <div className="flex md:hidden gap-3 overflow-x-auto pb-1 scrollbar-hide">
        {actions.map((action, index) => (
          <button
            key={index}
            onClick={() => action.path && navigate(action.path)}
            className="flex flex-col items-center gap-2 p-3 bg-white border border-gray-100 rounded-xl cursor-pointer shrink-0 w-[72px] active:scale-95 transition-transform"
          >
            <div className={`w-10 h-10 ${action.color} rounded-xl flex items-center justify-center`}>
              <i className={`${action.icon} text-lg`} />
            </div>
            <span className="text-[11px] font-medium text-gray-600 whitespace-nowrap">{action.label}</span>
          </button>
        ))}
      </div>

      {/* Desktop: grid */}
      <div className="hidden md:grid grid-cols-5 gap-4">
        {actions.map((action, index) => (
          <button
            key={index}
            onClick={() => action.path && navigate(action.path)}
            className="flex flex-col items-center gap-3 p-4 bg-white border border-gray-100 rounded-xl cursor-pointer group hover:border-teal-200 transition-colors"
          >
            <div className={`w-12 h-12 ${action.color} rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform`}>
              <i className={`${action.icon} text-xl`} />
            </div>
            <span className="text-sm font-medium text-gray-700">{action.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
